import {Component, OnInit} from '@angular/core';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {NgClass} from '@angular/common';
import {ValueModel, ValueService} from '../../services/value/value.service';
import {Subject, takeUntil} from 'rxjs';
import {MatInput} from '@angular/material/input';
import {FormsModule, NgModel} from '@angular/forms';
// import {DoctorCreateComponent} from '../doctor-create/doctor-create.component';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-administration-templates',
    standalone: true,
    imports: [
        CdkAccordion,
        CdkAccordionItem,
        NgClass,
        MatInput,
        FormsModule,
        // DoctorCreateComponent
    ],
    templateUrl: './administration-templates.component.html',
    styleUrl: './administration-templates.component.sass'
})
export class AdministrationTemplatesComponent implements OnInit {
    private destroy$ = new Subject<void>();
    drugDosages: ValueModel[] = []
    drugProcessings: ValueModel[] = []

    constructor(private valueService: ValueService, private dialog: MatDialog) {
    }

    ngOnInit() {
        this.getDosages();
        this.getProcessing();

    }

    addEmptyDosage() {
        this.drugDosages.push({id: '', value: ''});
    }

    addEmptyProcessing() {
        this.drugProcessings.push({id: '', value: ''});
    }

    saveDosageChanges(dosage: string, index: number, model: NgModel) {
        this.drugDosages[index].value = dosage;

        if (this.drugDosages[index].id === '') {
            this.postDosages(this.drugDosages[index], model);
        } else {
            this.putDosages(this.drugDosages[index], model)
        }
    }

    saveProcessingChanges(processing: string, index: number, model: NgModel) {
        this.drugProcessings[index].value = processing;
        if (this.drugProcessings[index].id === '') {
            this.postProcessing(this.drugProcessings[index], model)
        } else {
            this.putProcessing(this.drugProcessings[index], model)
        }
    }

    removeProcessing(id: string, index: number) {
        if (this.drugProcessings[index].id === '') {
            this.drugProcessings.splice(index, 1);
        } else {
            this.openConfirmDialog(id, 'Verarbeitung')
        }
    }

    removeDosage(id: string, index: number) {

        if (this.drugDosages[index].id === '') {
            this.drugDosages.splice(index, 1);
        } else {
            this.openConfirmDialog(id, 'Dosierung')
        }
    }

    private postDosages(value: ValueModel, model: NgModel) {
        this.valueService.postDosages(value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: response => {
                    value = response.data;
                    model.reset(response.data.value)
                },
                error: error => {
                }
            })
    }

    private getDosages(): void {
        this.valueService.getDosages()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.drugDosages = response.data;
                },
                error: (error) => {
                }
            })
    }

    private putDosages(value: ValueModel, model: NgModel) {
        this.valueService.putDosages(value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: response => {
                    value = response.data;
                    model.reset(response.data.value)
                },
                error: (error) => {
                }
            })
    }

    private getProcessing(): void {
        this.valueService.getProcessing()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.drugProcessings = response.data;
                },

                error: (error) => {
                }
            })
    }

    private postProcessing(value: ValueModel, model: NgModel): void {
        this.valueService.postProcessing(value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    value = response.data;
                    model.reset(response.data.value)
                },
                error: (error) => {
                }
            })
    }

    private putProcessing(value: ValueModel, model: NgModel) {
        this.valueService.putProcessing(value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: response => {
                    value = response.data;
                    model.reset(response.data.value)
                },
                error: (error) => {
                }
            })
    }

    private deleteProcessing(id: string) {
        this.valueService.deleteProcessing(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
            next: response => {
                this.getProcessing();
            },
            error: (error) => {}
        })
    }

    private deleteDosage(id: string) {
        this.valueService.deleteDosages(id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
            next: response => {
                this.getDosages();
            },
            error: (error) => {}
        })
    }

    private openConfirmDialog(id: string, type: string): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            closeOnNavigation: true,
            disableClose: false,
            data: {
                text: 'Möchten Sie die ' + type + ' wirklich löschen ?',
                header: type + ' löschen',
                delete: false
            }
        })

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (type === 'Dosierung') {
                    this.deleteDosage(id);
                } else {
                    this.deleteProcessing(id)
                }
            }
        })
    }

}
